<template>
  <q-timeline :layout="layout">
    <!-- Parent Timers -->
    <timeline-parent
      v-for="(parentTimer, index) in timelineData"
      :key="parentTimer.uuid"
      :parent-timer="parentTimer"
      :index="index"
    />
  </q-timeline>
</template>
<script setup lang="ts">
import { useQuasar } from 'quasar'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useTimers } from '../store/timers'
import TimelineParent from './TimelineParent.vue'
import { useGetOdometerReading } from '../composables/getOdometerReading'
import { useMapLocationsTravel } from '../composables/mapLocationsTravel'
import { v4 } from 'uuid'
import { isPropertyOfObjectNullish } from '../utils'

const $q = useQuasar()
const { getAllParentTimers } = storeToRefs(useTimers())

const timelineData = computed(() => {
  const newArray: any[] = []
  getAllParentTimers.value.forEach((parent, index, reverseTimers) => {
    //check if gap between parent timers
    if (
      !isPropertyOfObjectNullish(reverseTimers[index - 1], 'end_time') &&
      parent.start_time.getTime() - reverseTimers[index - 1].end_time!.getTime() > 300000 // 5 minutes
    ) {
      newArray.push({
        uuid: v4(), // just a unique key
        type: 'unknown',
        start_time: reverseTimers[index - 1].end_time,
        end_time: parent.start_time,
        editable: true,
        //used for defaulting locations/odometers when inserting timers
        data: {
          ...useMapLocationsTravel(index).departing.value,
          ...useMapLocationsTravel(index - 1).destination.value,
          lastParentIndex: index - 1,
          odometer_start: useGetOdometerReading({ index: index - 1 }).previous.value,
          odometer_end: useGetOdometerReading({ index: index }).next.value,
        },
      })
    }
    newArray.push({ ...parent, index: index })
  })

  return newArray.reverse()
})

const layout = computed(() => {
  return $q.screen.lt.sm ? 'dense' : $q.screen.lt.md ? 'comfortable' : 'loose'
})
</script>
<style>
.q-timeline__title {
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
}
.q-item__section--avatar {
  min-width: 16px;
}
.q-item__section--avatar {
  padding-right: 4px;
}
.q-list--dense > .q-item,
.q-item--dense {
  padding-left: 0;
}
.q-timeline--comfortable .q-timeline__subtitle {
  width: 170px;
}
.text-timestamp {
  font-size: 12px;
  margin-bottom: 8px;
  opacity: 0.6;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
}
.q-card__section--vert {
  padding: 0;
}
</style>
